import Butter from "buttercms";

const butter = Butter("<YOUR_API_KEY>");

export default butter;
